
import CountryService from './CountryService';

export { default } from './CountryService';
export const countryService = new CountryService();